import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { azureDataExplorerMetadata } from 'app/registries/linked-service/azure-data-explorer-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ModelConstants } from 'shell-models-lib';

/**
 * For `Trident🔱` Kusto workspace
 */
export const kustoDatabaseMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        ...(await azureDataExplorerMetadata(injector)),
        icon: {
            className: 'svg-i_KQL_database'
        },
        type: adfModelTypeMap.kustoDatabase.linkedServiceType,
        displayName: stringResources.KustoDatabase_DisplayText,
        disabled: !__IS_FABRIC_DPE__,
        pqoDataSourceOption: undefined,
        supportedAuthKindsInTrident: undefined,
        supportCopyJobSource: false,
        supportCopyJobSink: false,
        fabricArtifactType: ModelConstants.kustoDatabaseArtifactType,
        category: __IS_FABRIC_DPE__ ? ['Workspace'] : ['Azure'],
        supportDatasetV2: true,
        supportDataFlowSource: false,
        supportDataFlowSink: false,
        dataflowSource: [],
        dataflowSink: [],
        copySourceTypes: [adfModelTypeMap.kustoDatabase.copySourceType],
        copySinkTypes: [adfModelTypeMap.kustoDatabase.copySinkType]
    };

    return metadata;
};
